import { Routine } from 'redux-saga-routines';
import {
  fetchReferenceSurveyRoutine,
  confirmReferenceRoutine,
  answerQuestionRoutine,
  startSurveyRoutine,
  finishSurveyRoutine,
  fetchQuestionsRoutine,
  setPreviewDataRoutine,
  setPreviewAnswerRoutine,
  checkSurveyKeyRoutine,
  setRefContactInfoRoutine,
  checkSurveyCodeRoutine
} from '../routines';
import { ICandidateName } from '../../../common/models/candidate/ICandidateName';
import { IReferenceSurvey } from '../../../common/models/reference/IReferenceSurvey';
import { map } from 'ramda';
import { IQuestionForReference } from '../../../common/models/question/IQuestionForReference';
import { getRefForManualInputRoutine, resetRefSurveyDataRoutine } from '../../../containers/SurveyManualInput/routines';

export type RefSurveyState = {
  surveyStartDate?: Date;
  surveyCompleteDate?: Date;
  questionCount: number;
  isConfirming: boolean;
  error: string | null;
  candidate: ICandidateName;
  reference: IReferenceSurvey;
  questions: IQuestionForReference[];
  isChecking: boolean;
  errorCode?: string;
  isManualInput: boolean;
}

const initialState = {
  surveyStartDate: undefined,
  surveyCompleteDate: undefined,
  questionCount: 0,
  isConfirming: false,
  candidate: { } as ICandidateName,
  reference: { } as IReferenceSurvey,
  questions: [],
  error: null,
  isChecking: false,
  isManualInput: false
};

export const refSurvey = (state: RefSurveyState = initialState, { payload, type }: Routine<any>): RefSurveyState => {
  switch (type) {
    case fetchReferenceSurveyRoutine.SUCCESS:
    case getRefForManualInputRoutine.SUCCESS: {
      return { ...state, ...payload };
    }
    case confirmReferenceRoutine.TRIGGER:
      return {
        ...state,
        isConfirming: true
      };
    case confirmReferenceRoutine.SUCCESS:
      const { reference, questions } = payload;
      return {
        ...state,
        isConfirming: false,
        reference,
        questions
      };
    case fetchQuestionsRoutine.SUCCESS:
      return {
        ...state,
        questions: payload
      };
    case answerQuestionRoutine.SUCCESS:
      const { question: { id: questionId }, answer, id, extraReferenceQuestion } = payload;
      const newQuestions = map(q => (q.questionId === questionId
        ? ({
          ...q,
          id,
          answer,
          extraReferenceQuestion: {
            ...q.extraReferenceQuestion, answer: extraReferenceQuestion?.answer
          } })
        : q), state.questions);
      return {
        ...state,
        questions: newQuestions
      };
    case startSurveyRoutine.SUCCESS:
      return {
        ...state,
        surveyStartDate: new Date()
      };
    case finishSurveyRoutine.SUCCESS:
      return {
        ...state,
        surveyCompleteDate: new Date()
      };
    case setPreviewDataRoutine.TRIGGER:
      return {
        ...state,
        ...payload,
        questionCount: payload.questions.length
      };
    case setPreviewAnswerRoutine.TRIGGER:
      return {
        ...state,
        questions: map(q => (q.questionId === payload.questionId ? { ...q, ...payload } : q), state.questions)
      };
    case checkSurveyKeyRoutine.FAILURE:
      return {
        ...state,
        error: payload
      };
    case setRefContactInfoRoutine.TRIGGER:
      return {
        ...state,
        reference: { ...state.reference, ...payload }
      };
    case checkSurveyCodeRoutine.TRIGGER:
      return {
        ...state,
        isChecking: true,
        errorCode: undefined
      };
    case checkSurveyCodeRoutine.FAILURE:
      return {
        ...initialState,
        errorCode: payload
      };
    case checkSurveyCodeRoutine.SUCCESS:
      return {
        ...state,
        ...payload,
        isChecking: false
      };
    case resetRefSurveyDataRoutine.TRIGGER:
      return initialState;
    default:
      return state;
  }
};
